import { v4 as uuidv4 } from 'uuid';

export function TabContentItem(props = {}, childrenComponents = []) {
	return {
		componentName: 'TabContentItem',
		componentId: uuidv4(),
		props,
		childrenComponents,
	};
}
